import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import CTAButton from "@/components/base/CTAButton";

const links = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/solutions", label: "Solutions" },
  { to: "/work", label: "Work" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200"
          : "bg-transparent"
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-10">
        <div className="mx-auto flex h-16 md:h-[72px] items-center justify-between max-w-[1280px]">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="w-8 h-8 rounded-md  flex items-center justify-center">
              <img src="/images/icon.png" alt="logo" />
            </span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">
              EMCHON
              <span className="text-primary-600"> TECHNOLOGIES.</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                    isActive
                      ? "text-primary-600"
                      : "text-foreground-700 hover:text-foreground-950"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <CTAButton to="/contact" variant="primary" icon="ri-arrow-right-up-line">
              Get a Quote
            </CTAButton>
          </div>

          {/* Mobile hamburger */}
          <button
            type="button"
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-md text-foreground-900 cursor-pointer"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-2xl`}></i>
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-6 pt-2">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-base font-medium ${
                    isActive
                      ? "text-primary-600 bg-primary-50"
                      : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="pt-3">
              <CTAButton to="/contact" variant="primary" className="w-full" icon="ri-arrow-right-up-line">
                Get a Quote
              </CTAButton>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}